import classes from './CellOffsetsActions.module.css';
import { rem, Image, Popover, Box } from '@mantine/core';
import { Menu, ActionIcon } from '@mantine/core';
import IconDotsVertical from '@assets/icons/dots-vertical.svg';
import IconExternalLink from '@assets/icons/external-link.svg';

import {
	IconPlayerPlay,
	IconDownload,
	IconChevronRight,
	IconSend,
} from '@tabler/icons-react';
import styles from './CellOffsetsActions.module.css';
import { useTranslation } from 'react-i18next';
import { TOffset } from '@features/offsets/types';
import { useDisclosure } from '@mantine/hooks';
import { useAuthorization } from '@lib/authorization';
import { ROLES } from '@config/constants/roles';

const MenuItem = Menu.Item.withProps({
	mod: { hovered: false },
	onMouseOver: (e) => {
		e.currentTarget.setAttribute('data-hovered', 'false');
	},
});

export const CellOffsetsActions = (props: {
	handleviewmore: (data: TOffset) => void;
	handleSendCertificate: (
		data: TOffset | undefined
	) => void;
	handledownload: (id: string, lang: string) => void;
	row?: TOffset;
	opened?: boolean;
	enableCertification?: boolean;
	enableOffset?: boolean;
}) => {
	const { t } = useTranslation();
	const [opened, { close, open }] = useDisclosure(false);
	const { checkRole } = useAuthorization();

	return (
		<Menu
			opened={props.opened}
			shadow="xs"
			classNames={styles}
		>
			<Menu.Target>
				<ActionIcon
					data-testid="W2FtAXR6_Z5jdHi6B-menu"
					variant="transparent"
					className={classes.customSize}
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<Image
						style={{
							objectFit: 'contain',
							width: rem(25),
							height: rem(25),
						}}
						src={IconDotsVertical}
					/>
				</ActionIcon>
			</Menu.Target>
			<Menu.Dropdown>
				<Menu.Label>{t('global.offset')}</Menu.Label>
				<MenuItem
					data-testid="W2FtAXR5_Z5jdHi6B-menu"
					onClick={(event) => {
						event.stopPropagation();
						if (props && props.row) {
							props.handleviewmore(props.row);
						}
					}}
					color="var(--mantine-color-black)"
					className={styles.item}
					leftSection={
						<Image
							style={{
								objectFit: 'contain',
								width: rem(20),
								height: rem(20),
							}}
							src={IconExternalLink}
						/>
					}
				>
					{t('global.viewMore')}
				</MenuItem>
				{checkRole([
					ROLES.ADMIN,
					ROLES.SUPERADMIN,
					ROLES.STAFF,
					ROLES.ORGANIZATION_ADMIN,
					ROLES.ORGANIZATION_STAFF,
					ROLES.BRAND_ADMIN,
					ROLES.BRAND_STAFF,
				]) && (
					<>
						<Menu.Divider />
						<Menu.Label>
							{t('global.certification')}
						</Menu.Label>
						<Popover
							width={300}
							position="left-start"
							shadow="md"
							opened={opened}
							offset={2}
							transitionProps={{
								duration: 300,
							}}
						>
							<Popover.Target>
								<MenuItem
									onMouseEnter={open}
									onMouseLeave={close}
									rightSection={
										<IconChevronRight size={18} />
									}
									disabled={
										props.row && props.row.status
											? props.row.status !== 'SUCCESS'
											: false
									}
									data-testid="W200AXR4_Z5jdHi6B-menu"
									color="var(--mantine-color-black)"
									className={styles.customMenu}
									leftSection={
										<IconDownload
											style={{
												width: rem(20),
												height: rem(20),
											}}
										/>
									}
								>
									{t('global.download')}
								</MenuItem>
							</Popover.Target>

							<Popover.Dropdown
								style={{
									padding: '5px',
								}}
								w={110}
								onMouseEnter={open}
								onMouseLeave={close}
							>
								<Box
									onClick={(event) => {
										event.stopPropagation();
										if (props && props.row) {
											props.handledownload(
												props.row.id,
												'fr'
											);
										}
										close();
									}}
									className={classes.customItem}
								>
									<Image
										className={classes.logoCountry}
										src={`https://flagcdn.com/w40/fr.png`}
									/>{' '}
									{t('global.french')}
								</Box>
								<Box
									onClick={(event) => {
										event.stopPropagation();
										if (props && props.row) {
											props.handledownload(
												props.row.id,
												'en'
											);
											close();
										}
									}}
									className={classes.customItem}
								>
									<Image
										className={classes.logoCountry}
										src={`https://flagcdn.com/w40/us.png`}
									/>{' '}
									{t('global.english')}
								</Box>
							</Popover.Dropdown>
						</Popover>
						<MenuItem
							disabled={props.row?.status !== 'SUCCESS'}
							data-testid="W2FtAXR3_Z5jdHi6B-menu"
							onClick={(event) => {
								event.stopPropagation();
								props.handleSendCertificate(props.row);
							}}
							color="var(--mantine-color-black)"
							className={styles.item}
							leftSection={
								<IconSend
									style={{
										width: rem(20),
										height: rem(20),
									}}
								/>
							}
						>
							{t('global.send')}
						</MenuItem>
					</>
				)}
			</Menu.Dropdown>
		</Menu>
	);
};
